import { createAction, handleActions } from 'redux-actions';
import http from '../../utility/http';
import { api_candidate } from '../../constants/apiRoutes';

// ------------------------------------
// Constants
// ------------------------------------

const SET_CANDIDATE = 'SET_CANDIDATE';

const initialState = {
  candidate: {},
};

// ------------------------------------
// Actions
// ------------------------------------

const setCandidate = createAction(SET_CANDIDATE);

// ------------------------------------
// Reducers
// ------------------------------------

const reducers = {
  [SET_CANDIDATE]: (state, { payload }) => {
    return {
      ...state,
      candidate: payload,
    };
  },
};

// ------------------------------------
// API calls
// ------------------------------------

export const getCandidate = (dispatch, candidateId) => {
  return http.get(api_candidate(candidateId)).then(({ data }) => {
    dispatch(setCandidate(data));

    return data;
  });
};

export default handleActions(reducers, initialState);

// ------------------------------------
// "plain" action functions
// ------------------------------------

export const clearCandidate = () => setCandidate(initialState.candidate);
